import{
  FETCH_CONTACTS_DATA, CMS_CONTACTS_REQUEST
} from '../constants/contacts'


import contacts from '../utils/contacts/'

export function getAll(array) {
  return (dispatch) => {
    dispatch({
      type   : CMS_CONTACTS_REQUEST,
      payload: {
        fetching: true
      }
    })

    contacts.all(array).then(data => {
      dispatch({
        type   : FETCH_CONTACTS_DATA,
        payload: {
          data    : data,
          fetching: false
        }
      })
    });
  }
}
export function AddCustomersMessages(formData) {
  return (dispatch) => {
    dispatch({
      type   : CMS_CONTACTS_REQUEST,
      payload: {
        message: {
          data: null,
          fetching : true,
          checkMessage: false,
        }
      }
    })
    contacts.addCustomerMessage(formData).then(d => {
       let checkMessage = false
      if (d.id_customer_message!==0) {
        checkMessage = true
      }
        dispatch({
          type   : FETCH_CONTACTS_DATA,
          payload: {
            message: {
              data: d,
              fetching : false,
              checkMessage: checkMessage,
            }
          }
        })
     
    });
  }
}
export function addCustomersThreads(formData) {
  return (dispatch) => {
    dispatch({
      type   : CMS_CONTACTS_REQUEST,
      payload: {
        thread: {
          data: null,
          fetching : true,
          checkThread: false,
        }
      }
    });
    return new Promise((resolve, reject) => {
    contacts.addCustomerThread(formData).then(d => {
       let checkThread = 2
      if (d.id_customer_thread!==0) {
        checkThread = 1
      }
        dispatch({
          type   : FETCH_CONTACTS_DATA,
          payload: {
            thread: {
              data: d,
              fetching : false,
              checkThread: checkThread,
            }
          }
        })
        resolve(d);  // Résoudre la promesse avec les données
    }).catch((error) => {
      // Si une erreur se produit, rejeter la promesse avec l'erreur
      reject(error);
    });
  });
  }
}


// WEBPACK FOOTER //
// ./src/actions/contactsActions.js